import script from "./ManageAccount.vue?vue&type=script&setup=true&lang=js"
export * from "./ManageAccount.vue?vue&type=script&setup=true&lang=js"

import "./ManageAccount.vue?vue&type=style&index=0&id=1c7def81&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c7def81"]])

export default __exports__